import * as apiGet from 'api/errorMessage/GetErrorMessageIdV1';
import * as apiPost from 'api/errorMessage/PostErrorMessageV1';
import * as apiPut from 'api/errorMessage/PutErrorMessageV1';
import * as apiTranslate from 'api/translation/PostTranslationV1';
import { LocalizedTranslation } from 'types/_general/LocalizedTranslation';

export default class ErrorMessage {
	public id: string = '';
	public errorKey: string = '';
	public errorTranslations: LocalizedTranslation<string> = {};

	public constructor(input?: apiGet.ResponseData) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiTranslation(fromCultureCode: string, toCultureCode: string): Promise<void> {
		const response = await apiTranslate.callApi(
			this.mapToApiTranslate(fromCultureCode, toCultureCode)
		);
		response.hasValue() && this.mapFromApiTranslate(response.get(), toCultureCode);
	}

	public async callApiPut(): Promise<void> {
		await apiPut.callApi(this.id, this.mapToApiPut());
	}

	public async callApiPost(): Promise<void> {
		const response = await apiPost.callApi(this.mapToApiPost());
		response.hasValue() && this.mapFromApiPost(response.get());
	}

	private mapToApiTranslate(
		fromCultureCode: string,
		toCultureCode: string
	): apiTranslate.Request {
		return {
			fromCultureCode: fromCultureCode,
			toCultureCode: toCultureCode,
			text: this.errorTranslations[fromCultureCode],
		};
	}

	private mapToApiPost(): apiPost.Request {
		return {
			errorKey: this.errorKey,
			errorTranslations: this.errorTranslations,
		};
	}

	private mapToApiPut(): apiPut.Request {
		return {
			errorKey: this.errorKey,
			errorTranslations: this.errorTranslations,
		};
	}

	private mapFromApi(input: apiGet.ResponseData) {
		this.id = input.id;
		this.errorTranslations = input.errorTranslations;
		this.errorKey = input.errorKey;
	}

	private mapFromApiPost(input: string) {
		this.id = input;
	}

	private mapFromApiTranslate(input: string, toCultureCode: string) {
		this.errorTranslations[toCultureCode] = input;
	}
}
